<app-table
  [actionColumnWidth]="300"
  [columns]="columns"
  [loading]="loading"
  [value]="mandants"
  filename="MENU.MANDANTS">
  @if (isRodixAdmin()) {
    <ng-template (onClick)="add()" appToolbarButton icon="fal fa-plus" labelKey="MANDANTS.ADD_MANDANT"></ng-template>
  }

  @if (canDelete) {
    <ng-template
      (onClick)="delete($event.row)"
      appActionButton
      displayIfNot="deleting"
      icon="fal fa-trash"
      labelKey="ACTIONS.DELETE"
      type="danger"></ng-template>
    <ng-template
      (onClick)="deleteDataOnly($event.row)"
      appActionButton
      displayIfNot="deleting"
      icon="fal fa-undo"
      labelKey="ANWENDERBETRIEBE.DELETE_DATA_ONLY"
      type="warning"></ng-template>
    <ng-template
      [disabled]="true"
      appActionButton
      displayIf="deleting"
      icon="fal fa-hourglass-half"
      labelKey="ANWENDERBETRIEBE.DELETION_IN_PROGRESS"
      type="secondary"></ng-template>
  }
</app-table>
